import {computed, Service, signal} from '@angular/core'
import {TDomains} from './kalp.service'

@Service()
export class BorgoService {

  public borgoPossible = signal(false)

  public domain = computed<TDomains>(() => {
    return this.borgoPossible() ? 'borgo' : 'sparbanken'
  })
}
